// mixins
import mobileWrapperMixin from "@/mixins/mobile_wrapper/mobile-wrapper-mixin";

// services
import base64ToFile from "@/services/base64-service";
import axios from "axios";

// utils
import { dynamicParameter } from "@/mixins/service/mixin-service";
import {mapActions, mapGetters} from "vuex";
import SNACKBAR_TYPES from "@/utils/enum/SNACKBAR_TYPES";
import i18n from '@/language/i18n';

const NO_CALLBACK_ERROR = "No callback handed! Without a callback, camera-action will break after camera close. (mobile-camera-mixin.js)";
const NO_TARGET_FIELD_PATH_ERROR = "No targetFieldPath handed! Needed for mobile devices notifications. (mobile-camera-mixin.js)";

/**
 * @param {Function} callback
 * @param {String} targetFieldPath
 */
export default function (callback, targetFieldPath, taskPayload, singleMode = false) {
    const getCallback = dynamicParameter(callback);
    const getTargetFieldPath = dynamicParameter(targetFieldPath);
    const getTaskPayload = dynamicParameter(taskPayload);
    const getSingleMode = dynamicParameter(singleMode);

    if (!callback) { window.console.error(NO_CALLBACK_ERROR); }

    return {
        mixins: [mobileWrapperMixin],
        inject: ['_windowIdentifier'],
        computed: {
            ...mapGetters('actingUser', ['getActingUserDetails']),
        },
        methods: {
            ...mapActions('globalSnackbarStore', ['showSnackbarWithMessage']),
            /**
             * Invokes CameraAction with help of the MobileWrapper
             */
            async invokeCameraAction() {
                if (this.$isMobileDevice()) {
                    try {
                        let taskId = await this.setTask({ callback: getCallback(this), taskPayload: getTaskPayload(this)});

                        // eslint-disable-next-line no-undef
                        return invokeCSharpDirectCameraAction(taskId); // RENAME OR REMOVING WILL BREAK MOBILEWRAPPER
                    } catch (e) {
                        window.console.error(e);
                    }
                } else {
                    const response = await axios.get('/rest/v4/profile');
                    const linkedDevices = response?.data?.data?.linkedDevices;
                    if (!linkedDevices || linkedDevices.length === 0) {
                        this.showSnackbarWithMessage({
                            type: SNACKBAR_TYPES.INFO,
                            message: i18n.t('Components.sentences.noLinkedMobileDevices')
                        });
                        return;
                    }
                    if (!targetFieldPath) { window.console.error(NO_TARGET_FIELD_PATH_ERROR); }
                    this.$pushTakePhotoNotification({ ...this._windowIdentifier, targetFieldPath: getTargetFieldPath(this), taskPayload: getTaskPayload(this), singleMode: getSingleMode(this) });
                }
            },
        },
        mounted() {
            /**
             * Callback after camera of MobileWrapper closed.
             *
             * @param {string} taskId
             * @param {string} base64String
             */
            window.handleCSharpBase64DirectPhotoFile = async (taskId, base64Data) => {
                try {
                    let task = await this.getAndRemoveTask(taskId);
                    let files;
                    
                    const filePromises = base64Data.map(base64String => base64ToFile(base64String));
                    files = await Promise.all(filePromises);
                    
                    task.callback(files, taskId);
                } catch (e) {
                    window.console.error('Error processing camera files:', e);
                }
            }
        },
        beforeDestroy() {
            delete window.handleCSharpBase64DirectPhotoFile;
        }
    }
}
